export type EnvName = 'prod' | 'stg' | 'dev'

export interface EnvTheme {
  name: EnvName
  label: string
  showBadge: boolean
  headerGradient: string
  logoBtnHover: string
  logoIconColor: string
  subText: string
  logoutText: string
  logoutHoverBg: string
  pageGradient: string
  primaryHex: string
  badgeBg: string
  badgeText: string
}

const detectEnv = (): EnvName => {
  const override = (import.meta.env.VITE_APP_ENV as string | undefined)?.toLowerCase()
  if (override === 'prod' || override === 'stg' || override === 'dev') return override
  const host = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : ''
  if (!host || host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local') || host.startsWith('192.168.')) {
    return 'dev'
  }
  if (host.includes('stg') || host.includes('staging')) return 'stg'
  return 'prod'
}

const themes: Record<EnvName, EnvTheme> = {
  prod: {
    name: 'prod',
    label: '本番環境',
    showBadge: false,
    headerGradient: 'from-blue-700 to-blue-600',
    logoBtnHover: 'hover:bg-blue-50',
    logoIconColor: '!text-blue-700',
    subText: 'text-blue-100',
    logoutText: 'text-blue-700',
    logoutHoverBg: 'hover:bg-blue-50',
    pageGradient: 'from-slate-100 to-blue-50',
    primaryHex: '#2563eb',
    badgeBg: 'bg-blue-900/40',
    badgeText: 'text-white',
  },
  stg: {
    name: 'stg',
    label: '検証環境',
    showBadge: true,
    headerGradient: 'from-amber-600 to-yellow-500',
    logoBtnHover: 'hover:bg-amber-50',
    logoIconColor: '!text-amber-700',
    subText: 'text-amber-50',
    logoutText: 'text-amber-700',
    logoutHoverBg: 'hover:bg-amber-50',
    pageGradient: 'from-slate-100 to-amber-50',
    primaryHex: '#d97706',
    badgeBg: 'bg-amber-900/50',
    badgeText: 'text-white',
  },
  dev: {
    name: 'dev',
    label: '開発環境',
    showBadge: true,
    headerGradient: 'from-rose-700 to-red-600',
    logoBtnHover: 'hover:bg-rose-50',
    logoIconColor: '!text-rose-700',
    subText: 'text-rose-100',
    logoutText: 'text-rose-700',
    logoutHoverBg: 'hover:bg-rose-50',
    pageGradient: 'from-slate-100 to-rose-50',
    primaryHex: '#e11d48',
    badgeBg: 'bg-rose-900/50',
    badgeText: 'text-white',
  },
}

let cached: EnvTheme | null = null

export const getEnvTheme = (): EnvTheme => {
  if (!cached) cached = themes[detectEnv()]
  return cached
}
